import { timePeriodTypeDetails } from './types/TimePeriodTypes';

const getTimePeriodDisplay = (timePeriodTypeId) => {
  const timePeriodType = timePeriodTypeDetails[timePeriodTypeId];
  return timePeriodType && timePeriodType.display;
};

// eslint-disable-next-line import/prefer-default-export
export const formatSchedules = (schedules) => schedules.map((s) => {
  const startDay = getTimePeriodDisplay(s.startTimePeriodTypeId);
  const endDay = getTimePeriodDisplay(s.endTimePeriodTypeId);
  const startTime = `${String(s.startHours).padStart(2, '0')}:${String(s.startMinutes).padStart(2, '0')}`;
  const endTime = `${String(s.endHours).padStart(2, '0')}:${String(s.endMinutes).padStart(2, '0')}`;

  return `${startDay} ${startTime} - ${endDay} ${endTime}`;
}).join(', ');
